import { DefinitionTarget } from '@boma/supplier-portal/shared/entities';

export interface IGlobalFilters {
  productIds?: string[];
  locationIds?: string[];
  customerIds?: string[];
  categoryIds?: string[];
  departmentIds?: string[];
  brandIds?: string[];
  definitionsFilters?: {
    targets: DefinitionTarget;
    definitionIds: string[];
  };
}
